import React, { useState, useEffect } from 'react';
import './ImageManager.css';

const ImageManager = ({ existingImages = [], onImagesChange, propertyId }) => {
  const [images, setImages] = useState(existingImages);
  const [draggedIndex, setDraggedIndex] = useState(null);

  useEffect(() => {
    setImages(existingImages);
  }, [existingImages]);

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.currentTarget.style.opacity = '0.4';
  };

  const handleDragEnd = (e) => {
    e.currentTarget.style.opacity = '1';
    setDraggedIndex(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    
    if (draggedIndex === null || draggedIndex === dropIndex) {
      return;
    }

    const newImages = [...images];
    const draggedImage = newImages[draggedIndex];
    
    // Remove dragged item
    newImages.splice(draggedIndex, 1);
    // Insert at new position
    newImages.splice(dropIndex, 0, draggedImage);
    
    setImages(newImages);
    if (onImagesChange) {
      onImagesChange(newImages);
    }
  };

  const handleDelete = async (index, imageUrl) => {
    if (!window.confirm('Are you sure you want to delete this image?')) {
      return;
    }

    const newImages = images.filter((_, i) => i !== index);
    setImages(newImages);
    
    if (onImagesChange) {
      onImagesChange(newImages, [imageUrl]);
    }
  };

  if (!images || images.length === 0) {
    return (
      <div className="image-manager">
        <p className="no-images-message">No images yet. Upload some images to get started.</p>
      </div>
    );
  }

  return (
    <div className="image-manager">
      <p className="image-manager-hint">
        Drag images to reorder. Click the × button to delete an image.
        {images.length > 0 && ' The first image will be the main display image.'}
      </p>
      <div className="image-grid">
        {images.map((imageUrl, index) => (
          <div
            key={`${imageUrl}-${index}`}
            className="image-item"
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragEnd={handleDragEnd}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
          >
            <button
              className="delete-image-btn"
              onClick={() => handleDelete(index, imageUrl)}
              type="button"
              title="Delete image"
            >
              ×
            </button>
            <img src={imageUrl} alt={`Property ${index + 1}`} />
            {index === 0 && <div className="main-image-badge">Main</div>}
            <div className="image-number">{index + 1}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageManager;
